<p-table [columns]="columnLabels.weeks" [value]="dataSource">
  <ng-template pTemplate="header" let-columns>
    <tr [class]="'table__header--' + companyEnum.ALP.toLocaleLowerCase()">
      <th class="table__header--uppercase">
        {{ columnLabels.title }}
      </th>
      <th>{{ columnLabels.type }}</th>
      <th>
        <div>{{ columnLabels.meals }}</div>
        (Per week)
      </th>
      <th>{{ columnLabels.bathroom }}</th>
      <th>{{ columnLabels.minAge }}</th>
      <th *ngFor="let column of columns">
        <div>{{ column.header }}</div>
        <div>({{ column.subHeader }})</div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data let-columns="columns">
    <tr *ngFor="let option of data.options; let first = first; let last = last">
      <td [class.table__cell--no-border-bottom]="!last">
        <ng-container *ngIf="first">
          {{ data.name }} <sup>{{ notationMarks[data.noteCode] }}</sup>
        </ng-container>
      </td>
      <td>
        {{ option.type ?? '-' }} <sup>{{ notationMarks[option.noteCode] }}</sup>
      </td>
      <td>{{ option.meals ?? '-' }}</td>
      <td class="bathroom">{{ option.bathroom ?? '-' }}</td>
      <td>{{ option.minAge ?? '-' }}</td>
      <td *ngFor="let column of columns">
        {{ option.prices[column.band] | lxPrice : { defaultValue: '-' } }}
      </td>
    </tr>
  </ng-template>
</p-table>
